import tagTester from './_tagTester.js';

export default tagTester('Object');



//////////////////
// WEBPACK FOOTER
// ./node_modules/underscore/modules/_hasObjectTag.js
// module id = 200
// module chunks = 0 1